import React from 'react';
import { CardContent, Typography } from '@mui/material';

interface DriverInformationProps {
  driver: string;
  truck: string;
  purchaseOrderId: string;
  description: string;
}

const DriverInformation: React.FC<DriverInformationProps> = ({ driver, truck, purchaseOrderId, description }) => {
  return (
      <>
        <Typography variant="h6" gutterBottom>
          Driver Information
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Driver name: <strong>{driver}</strong>
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Truck: <strong>{truck}</strong>
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Transport Company: <strong>Snel Transport bv </strong>
        </Typography>
        <br />
        <Typography variant="h6" gutterBottom>
          Goods
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Purchase Order ID: <strong>{purchaseOrderId}</strong>
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Description: <strong>{description}</strong>
        </Typography>
      </>
  );
};

export default DriverInformation;
